<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="500"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <v-card>
      <v-row v-if="loading">
        <v-col cols="12">
          <px-circular-loading/>
        </v-col>
      </v-row>

      <v-list-item v-if="!loading && oferta">
        <v-list-item-content>
          <v-row dense>
            <v-col cols="12">
              <px-input-money
                dense
                ref="precoPraticado"
                class="required"
                label="Preço original"
                v-model="oferta.precoOriginal"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <px-input-money
                dense
                ref="precoPraticado"
                class="required"
                label="Preço à vista"
                v-model="oferta.precoAVista"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <px-input-money
                dense
                ref="precoPraticado"
                class="required"
                label="Preço à prazo"
                v-model="oferta.precoAPrazo"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-switch
                hide-details
                class="switch-dense"
                v-model="oferta.ativo"
                label="Oferta ativa"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                hide-details
                class="switch-dense"
                v-model="oferta.disponivel"
                label="Disponível"
              ></v-switch>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <v-card-actions>
        <v-btn color="primary" :loading="loadingSave" @click="save">
          Salvar
        </v-btn>
        <v-btn @click="close">
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { NumberUtils } from 'px-components';
import OfertaService from './oferta-service';

export default {
  props: {
    ofertaParam: Object,
  },
  data() {
    return {
      oferta: null,
      loading: false,
      loadingSave: false,
      menuOpened: false,
    };
  },
  methods: {
    close() {
      this.menuOpened = false;
    },
    setupEditing() {
      this.oferta.precoOriginal = NumberUtils.fixNumberInput(this.oferta.precoOriginal);
      this.oferta.precoAVista = NumberUtils.fixNumberInput(this.oferta.precoAVista);
      this.oferta.precoAPrazo = NumberUtils.fixNumberInput(this.oferta.precoAPrazo);
    },
    getOferta() {
      this.loading = true;
      OfertaService.get(this.ofertaParam.id)
        .then(({ data }) => {
          this.oferta = data;
          this.setupEditing();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.loadingSave = true;
      OfertaService.save(this.oferta)
        .then(() => {
          this.$toast('Oferta salva com sucesso', { color: 'success' });
          this.$emit('change');
          this.close();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    setupInitialState() {
      this.getOferta();
    },
  },
  watch: {
    menuOpened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.setupInitialState();
      }
    },
  },
};
</script>

<style scoped>
.switch-dense {
  margin-top: 0;
  padding-top: 0;
}
</style>
